const WAITING_RESULT = ['IN_PROGRESS', 'PENDING_REVIEW']
const PENDING_RESOLUTION_HREF = ['PENDING_CONTINUED_ELIGIBILITY', 'PENDING_RESOLUTION', 'PENDING_CONTINUED_ELIGIBILITY_BATCH', 'PENDING_RESOLUTION']

export {
    WAITING_RESULT, PENDING_RESOLUTION_HREF
}